var _style, _g, _g2, _g3, _g4, _g5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZeeves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 308.1 436.1",
    width: 1766,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#49c1bf}.st1{fill:#077a8f}.st2{fill:#298e97}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.693 -109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0_fill",
    className: "st0",
    d: "M117.4 289.2l-62.8 28L-112 402l166.6 80.1V349.7l62.8-28.3V517l-62.8 28-245.3-117.4v-62.4l169.8-83.3-169.8-81.6V137l63.8-28 244.3 117.6v62.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.693 -109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1_fill",
    className: "st1",
    d: "M-190.7 137L54.6 254.6l62.8-28L-126.9 109l-63.8 28z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.695 -100.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2_fill",
    className: "st2",
    d: "M36.6 245.7l62.8-28v62.6l-62.8 28v-62.6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.693 -106.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3_fill",
    className: "st0",
    d: "M-190.7 135v63.3l169.8 81.6-169.8 83.3v62.4L54.6 543v-62.8L-112 400l166.6-84.8v-62.6L-190.7 135z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.695 -93.411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4_fill",
    className: "st2",
    d: "M36.6 529l62.8-28V305.4l-62.8 28.3V529z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeeves);
export default __webpack_public_path__ + "static/media/zeeves.1e01a170.svg";
export { ForwardRef as ReactComponent };